import { render, staticRenderFns } from "./RePhoneCallButton.vue?vue&type=template&id=8f69d9d2&scoped=true"
import script from "./RePhoneCallButton.vue?vue&type=script&lang=js"
export * from "./RePhoneCallButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f69d9d2",
  null
  
)

export default component.exports